// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notifications-wrapper ul[data-v-46476210]{margin-bottom:0}", "",{"version":3,"sources":["webpack://./resources/js/components/Notifications.vue"],"names":[],"mappings":"AAEI,2CACI,eADR","sourcesContent":["\n.notifications-wrapper {\n    ul {\n        margin-bottom: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
